import { render, staticRenderFns } from "./editFeeConfig.vue?vue&type=template&id=7576461e&scoped=true"
import script from "./editFeeConfig.vue?vue&type=script&lang=js"
export * from "./editFeeConfig.vue?vue&type=script&lang=js"
import style0 from "./editFeeConfig.vue?vue&type=style&index=0&id=7576461e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7576461e",
  null
  
)

export default component.exports